import type { HelpFile } from '../../types/help'
import { EffectiveAccessBySystemTestIds } from '../../../testids/EffectiveAccessBySystemTestIds'

export const effectiveAccessBySystemHelp: HelpFile = {
  docPage: '/docs/analytics/effective-access',
  texts: {
    [EffectiveAccessBySystemTestIds.effectiveAccessBySystemPage]: 'Effektive Berechtigung aufgeschlüsselt nach Zielsystem — in ein System einsteigen zeigt Identitäten und deren Zugriffsrechte.',
    [EffectiveAccessBySystemTestIds.colActions]: null,
    [EffectiveAccessBySystemTestIds.colEnvironment]: 'Umgebung, in der das Zielsystem betrieben wird (Produktion, Staging usw.).',
    [EffectiveAccessBySystemTestIds.colSystem]: null,
    [EffectiveAccessBySystemTestIds.colType]: 'Typ des Zielsystems (LDAP, SCIM, Datenbank usw.).',
  },
}
